module.exports = __webpack_public_path__ + "static/img/share_img01.d98ec1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share_img01.png
// module id = b46t
// module chunks = 1